import KioskCard from '../components/KioskCard';
import globe from '../assets/lobbyKiosk/globe.svg';
import dark_globe from '../assets/lobbyKiosk/dark/dark-globe.svg';
import bulb from '../assets/lobbyKiosk/bulb.svg';
import dark_bulb from '../assets/lobbyKiosk/dark/dark-bulb.svg';
import carMiles from '../assets/lobbyKiosk/carMiles.svg';
import dark_carMiles from '../assets/lobbyKiosk/dark/dark-carMiles.svg';
import trees from '../assets/lobbyKiosk/trees.svg';
import dark_trees from '../assets/lobbyKiosk/dark/dark-trees.svg';
import coalBurned from '../assets/lobbyKiosk/coalBurned.svg';
import dark_coalBurned from '../assets/lobbyKiosk/dark/dark-coalBurned.svg';
import energyPurchased from '../assets/lobbyKiosk/energyPurchased.svg';
import dark_energyPurchased from '../assets/lobbyKiosk/dark/dark-energyPurchased.svg';
import solar from '../assets/kiosk/solar.svg';
import dark_solar from '../assets/lobbyKiosk/dark/dark-solar.svg';
import meter from '../assets/kiosk/gxMeter.svg';
import dark_gxMeter from '../assets/lobbyKiosk/dark/dark-gxMeter.svg';
import batteryIcon0 from '../assets/kiosk/battery0.svg';
import batteryIcon25 from '../assets/kiosk/battery25.svg';
import batteryIcon50 from '../assets/kiosk/battery50.svg';
import batteryIcon75 from '../assets/kiosk/battery75.svg';
import batteryIcon100 from '../assets/kiosk/battery100.svg';

let batteryIcon;
let batteryDisplaySoc;

// show or hide cards for ENERGY
let shouldShowEnergyConsumed;
let shouldShowEnergyGenerated;
let shouldShowEnergyNet;
let shouldShowEnergyPurchased;

// show or hide cards for CO2 EQUIVALENCIES
let shouldShowAvoidedCO;
let shouldShowCarMiles;
let shouldShowCarKm;
let shouldShowTreesPlanted;
let shouldShowCoalBurned;

// formatted values
let formattedEnergyConsumed;
let formattedEnergyGenerated;
let formattedNetEnergy;
let formattedEnergyPurchased;
let formattedCO2;
let formattedCoalBurned;
let formattedTrees;
let formattedCarMiles;
let formattedCarKm;

let noModelCards = [];
let energyCards = [];
let co2Cards = [];
let footerCards;

//Format stats
const formatValue = (value) => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

function createKioskCard(key, className, value, label, icon, icon_dark, darkMode) {
  return (
    <KioskCard
      key={key}
      className={className}
      value={value}
      label={label}
      icon={icon}
      icon_dark={icon_dark}
      darkMode={darkMode}
    />
  );
}

function kioskCards(currentGXData, isDarkMode) {
  let darkMode = isDarkMode;

  batteryDisplaySoc = currentGXData.kiosk.batteryDisplaySoc;

  switch (batteryDisplaySoc) {
    case 0:
      batteryIcon = batteryIcon0;
      break;
    case 25:
      batteryIcon = batteryIcon25;
      break;
    case 50:
      batteryIcon = batteryIcon50;
      break;
    case 75:
      batteryIcon = batteryIcon75;
      break;
    case 100:
      batteryIcon = batteryIcon100;
      break;
    default:
      batteryIcon = batteryIcon0;
      break;
  }

  formattedEnergyConsumed = formatValue(currentGXData.kiosk.thirtyDayEnergyConsumedkWh);
  formattedEnergyGenerated = formatValue(currentGXData.kiosk.thirtyDayEnergyGeneratedkWh);
  formattedNetEnergy = formatValue(currentGXData.kiosk.thirtyDayNetEnergykWh);
  formattedEnergyPurchased = formatValue(currentGXData.kiosk.thirtyDayEnergyPurchasedkWh);
  formattedCO2 = formatValue(currentGXData.kiosk.thirtyDayAvoidedCo2MetricTons);
  formattedCoalBurned = formatValue(currentGXData.kiosk.thirtyDayCo2OffsetPoundsOfCoalBurned);
  formattedTrees = formatValue(currentGXData.kiosk.thirtyDayCo2OffsetTreesPlanted);
  formattedCarMiles = formatValue(currentGXData.kiosk.thirtyDayCo2OffsetCarMiles);
  formattedCarKm = formatValue(currentGXData.kiosk.thirtyDayCo2OffsetCarKilometers);

  // Cards to show or hide for ENERGY
  shouldShowEnergyConsumed = currentGXData.kiosk.displayThirtyDayEnergyConsumedkWh;
  shouldShowEnergyGenerated = currentGXData.kiosk.displayThirtyDayEnergyGeneratedkWh;
  shouldShowEnergyNet = currentGXData.kiosk.displayThirtyDayNetEnergykWh;
  shouldShowEnergyPurchased = currentGXData.kiosk.displayThirtyDayEnergyPurchasedkWh;

  // Cards to show or hide for CO2 EQUIVALENCIES
  shouldShowAvoidedCO = currentGXData.kiosk.displayThirtyDayAvoidedCo2MetricTons;
  shouldShowCarMiles = currentGXData.kiosk.displayThirtyDayCo2OffsetCarMiles;
  shouldShowCarKm = currentGXData.kiosk.displayThirtyDayCo2OffsetCarKilometers;
  shouldShowTreesPlanted = currentGXData.kiosk.displayThirtyDayCo2OffsetTreesPlanted;
  shouldShowCoalBurned = currentGXData.kiosk.displayThirtyDayCo2OffsetPoundsOfCoalBurned;

  // ENERGY CARDS TO SHOW
  if (shouldShowEnergyConsumed) {
    energyCards = [
      ...energyCards,
      createKioskCard(
        'energy-consumed-card',
        'energy-consumed',
        `${formattedEnergyConsumed} kWh`,
        'Consumed',
        meter,
        dark_gxMeter,
        darkMode
      ),
    ];
  }

  if (shouldShowEnergyGenerated) {
    energyCards = [
      ...energyCards,
      createKioskCard(
        'energy-generated-card',
        'energy-generated',
        `${formattedEnergyGenerated} kWh`,
        'Generated',
        solar,
        dark_solar,
        darkMode
      ),
    ];
  }

  if (shouldShowEnergyNet) {
    energyCards = [
      ...energyCards,
      createKioskCard(
        'energy-net-card',
        'energy-net',
        `${formattedNetEnergy} kWh`,
        'Net Energy',
        bulb,
        dark_bulb,
        darkMode
      ),
    ];
  }

  if (shouldShowEnergyPurchased) {
    energyCards = [
      ...energyCards,
      createKioskCard(
        'energy-purchased-card',
        'energy-purchased',
        `${formattedEnergyPurchased} kWh`,
        'Purchased',
        energyPurchased,
        dark_energyPurchased,
        darkMode
      ),
    ];
  }

  // CO2 CARDS TO SHOW
  if (shouldShowAvoidedCO) {
    co2Cards = [
      ...co2Cards,
      createKioskCard(
        'avoided-co-card',
        'avoided-co',
        formattedCO2,
        'Avoided Tons',
        globe,
        dark_globe,
        darkMode
      ),
    ];
  }

  if (shouldShowCarMiles) {
    co2Cards = [
      ...co2Cards,
      createKioskCard(
        'car-miles-card',
        'car-miles',
        formattedCarMiles,
        'Car Miles Driven',
        carMiles,
        dark_carMiles,
        darkMode
      ),
    ];
  }

  if (shouldShowCarKm) {
    co2Cards = [
      ...co2Cards,
      createKioskCard(
        'car-km-card',
        'car-km',
        formattedCarKm,
        'Car Kilometers Driven',
        carMiles,
        dark_carMiles,
        darkMode
      ),
    ];
  }

  if (shouldShowTreesPlanted) {
    co2Cards = [
      ...co2Cards,
      createKioskCard(
        'trees-planted-card',
        'trees-planted',
        formattedTrees,
        'Trees Planted',
        trees,
        dark_trees,
        darkMode
      ),
    ];
  }

  if (shouldShowCoalBurned) {
    co2Cards = [
      ...co2Cards,
      createKioskCard(
        'coal-burned-card',
        'coal-burned',
        formattedCoalBurned,
        'Coal Burned',
        coalBurned,
        dark_coalBurned,
        darkMode
      ),
    ];
  }

  let energyDisplay = energyCards.slice(0, 2);
  let co2Display = co2Cards.slice(0, 2);

  noModelCards = [energyDisplay, co2Display];

  // FOOTER CARDS
  footerCards = [
    // <div className="total-energy content-block">
    //     <img src={darkMode ? dark_bulb : bulb} alt="Lit up light bulb icon" width="54" height="57" />
    //     <div className="stats">
    //         <p className='label'>Total Energy Produced</p>
    //         <p className='value'>{formattedEnergyGenerated} kWh</p>
    //     </div>
    // </div>
  ];

  if (currentGXData?.kiosk?.hasBattery) {
    footerCards = [
      ...footerCards,
      <div className="battery-soc content-block" key={'footer-item'}>
        <img className="icon" src={batteryIcon} alt="Battery Icon" width="54" height="57" />
        <div className="stats">
          <p className="label">Battery</p>
          <p className="value">
            {currentGXData.kiosk.batterySoc} % / {currentGXData.kiosk.batterySockWh} kWh
          </p>
        </div>
      </div>,
    ];
  }
}

export { kioskCards, energyCards, co2Cards, noModelCards, footerCards };
